
import uniqBy from 'lodash/uniqBy'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import FacetsFilters from '../Facets'
import PriceFilter from '../PriceFilter'

import {
  COMPATIBLE_CARRIERS_FACET,
  SIM_LOCK_FACET,
  SIM_LOCK_STATE_FACET,
} from './Refinements.constants'
import translations from './Refinements.translations'

export default {
  components: {
    FacetsFilters,
    PriceFilter,
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      experiments: 'flags/getExperiments',
      facets: 'landingSearch/facets',
      maxPrice: 'landingSearch/maxPrice',
      minPrice: 'landingSearch/minPrice',
    }),
    isPriceRange() {
      return this.minPrice !== this.maxPrice
    },
    shouldDisplayNewCarrierFilter() {
      return (
        this.experiments.lpImproveCarrierFilter === 'withOneFilterAbove' &&
        Boolean(this.newCarrierFilter)
      )
    },
    newCarrierFilter() {
      return this.facets.find((facet) => facet.facetName === SIM_LOCK_FACET)
    },
    filteredFacets() {
      const shouldDisplayNewCarrierFilter =
        this.experiments.lpImproveCarrierFilter === 'withOneFilterAbove'

      return uniqBy(this.facets, 'facetName').filter((value) => {
        const shouldExcludeOldCarrierFilters =
          shouldDisplayNewCarrierFilter &&
          (value.facetName === SIM_LOCK_STATE_FACET ||
            value.facetName === COMPATIBLE_CARRIERS_FACET)

        return (
          value.facetName !== SIM_LOCK_FACET && !shouldExcludeOldCarrierFilters
        )
      })
    },
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
    handleFacetFilter(facetGroup, value) {
      trackClick({
        name: facetGroup.facetName,
        zone: 'product list > side filter',
        // If value is null, we clicked "All" option to reset the facet
        value: value ?? ['All'],
      })

      this.$emit('change', { [facetGroup.facetName]: value })
    },
  },
}
